import ability from '@/libs/ability'

class RouteHelper {
  canNavigate = to => to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource))
}

export default new RouteHelper()
